import { gql } from '@apollo/client'

export const FETCH_USER_FILE = gql`
  query file($id: ID!) {
    file(id: $id) {
      id
      fileName
      downloadFileUrl
    }
  }
`
